// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"baa75ab5","459":"59894ba0","631":"1540cb58","760":"307a5b0d","774":"f522c5d5"}[chunkId] + ".chunk.js";
};